import { saveSurvey } from "./surveyServices";
import { initSaveSurveyProcess, saveSurveyProcess, saveSurveyProcessError } from "./surveySlice";

export const saveSurveyThunk = surveyData => async dispatch => {
    dispatch(initSaveSurveyProcess())
    try {
        const response = await saveSurvey(surveyData);
        console.log(response)
        if (response.status === 201) {
            dispatch(saveSurveyProcess(response.data))
        } else {
            dispatch(saveSurveyProcessError())
        }
    } catch (error) {
        dispatch(saveSurveyProcessError())
    }
}